<template>
  <v-container fluid>
    <v-row align="center" justify="center">
        <v-col cols="12" class="text-center">
            <div class="headline">Reset Password Required</div>
            <div class="mt-4">To keep your account secure you are required to reset your password.</div>
            <div class="mt-4 headline teal--text">We have sent an email to <b>{{email}}</b> with instructions to reset your password. Please check your inbox and make sure the email is not in the SPAM folder.</div>
            <v-icon large class="mt-4 teal--text">email</v-icon>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: ''
  }),
  created () {
    this.email = this.$route.query.email
  },
  computed: {
  },
  methods: {
  }
}
</script>
